import {
  InventoryApi,
  V1UsersUserIdItemsItemTypeItemTargetIdIsOwnedGetRequest,
} from '@rbx/clients/inventory';
import { Configuration } from '@rbx/clients';
import { getBEDEV1ServiceBasePath } from '@modules/utilities/constants/baseUrl';

export class InventoryClient {
  private inventoryApi: InventoryApi;

  constructor(basePath: string = getBEDEV1ServiceBasePath('inventory')) {
    const defaultConfig = new Configuration({
      basePath,
      credentials: 'include',
    });

    this.inventoryApi = new InventoryApi(defaultConfig);
  }

  async getIsItemOwned(
    request: V1UsersUserIdItemsItemTypeItemTargetIdIsOwnedGetRequest,
  ): Promise<boolean> {
    const { raw } =
      await this.inventoryApi.v1UsersUserIdItemsItemTypeItemTargetIdIsOwnedGetRaw(request);

    return raw.json();
  }
}

const inventoryClient = new InventoryClient();
export default inventoryClient;
